// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable i18next/no-literal-string */
'use client'
import Error from 'next/error'
import { useEffect } from 'react'

import { CONFIG_NODE_ENV } from '@src/config/env'
import SomethingWentWrongPageEnglish from '@src/quince-site-common/src/organisms/appLayout/molecules/errorBoundary/somethingWentWrong/ErrorPageEnglish'
import { captureFatalException } from '@src/quince-site-common/src/utils/sentryUtil'

export default function GlobalError({ error, reset }: { error: Error; reset: () => void }) {
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    captureFatalException(error)
  }, [error])

  return (
    <html>
      <body className="_error _error.page.tsx">
        {CONFIG_NODE_ENV === 'development' ? (
          <>
            <h1>Sorry.. there was an error</h1>
            <pre>{JSON.stringify(error, null, 2)}</pre>
          </>
        ) : (
          <SomethingWentWrongPageEnglish showHeader />
        )}
        <button
          onClick={() => {
            reset()
          }}
        >
          Try again
        </button>
      </body>
    </html>
  )
}
